module.exports = __webpack_public_path__ + "static/media/QuestLogo.e54a6f65.png";